// src/utils/auth.js

export const logoutUser = (navigate = null) => {
  // 1. Clear all auth tokens
  localStorage.clear();

  // 2. Redirect to login
  // If we passed the navigate function from react-router, use it (faster)
  if (navigate) {
    navigate("/dispatcher-login", { replace: true });
  } else {
    // Fallback: Force a hard reload to the login page
    window.location.href = "/dispatcher-login";
  }
};